import { useBusinessProfileStore } from '../session/store/useBusinessProfileStore';
import { useGlobalFeatureFlags } from '../providers/GlobalFeatureFlagsProvider';
import { isPublicStoreFeaturesVisible } from './publicStoreFeaturesGate';
import { isOperationModeStorefrontOff, parseOperationMode } from '../session/domain/operationMode';

/** Flag global + rubro permitido + toggle de modo de operación. */
export function usePublicStoreFeaturesVisible(): boolean {
  const { flags } = useGlobalFeatureFlags();
  const profile = useBusinessProfileStore((s) => s.profile);
  const storefrontEnabled = !isOperationModeStorefrontOff(parseOperationMode(profile?.business_config));
  return isPublicStoreFeaturesVisible(flags, profile?.business_type_code ?? null, storefrontEnabled);
}
